module.exports = __webpack_public_path__ + "static/media/cloud-data-connection.1532a81c.svg";